import {
  createStyles,
  makeStyles,
  TableCell,
  Theme,
  withStyles,
} from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  table: {
    minWidth: 650,
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  filter: {
    marginTop: '1%',
    marginBottom: '1%',
  },
  item: {
    paddingRight: '4%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    boxShadow: 'none',
    paddingInline: theme.spacing(2),
  },
  filterCard: {
    padding: theme.spacing(2),
    borderRadius: 12,
    marginBottom: theme.spacing(2),
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },
  filterLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: theme.spacing(0.5),
    display: 'block',
  },
  filterField: {
    width: '100%',
  },
  toggleField: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    marginLeft: 0,
  },
}));

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);
